import { TenantEntity } from '../TenantEntity'

export class OpenPrice extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'OpenPrice'
  }

  get branchId() {
    return this._data.branchId
  }

  set branchId(branchId) {
    this._data.branchId = branchId || 0
  }

  get batchUuid() {
    return this._data.batchUuid
  }

  set batchUuid(batchUuid) {
    this._data.batchUuid = batchUuid || ''
  }

  get filingBatchNo() {
    return this._data.filingBatchNo
  }

  set filingBatchNo(filingBatchNo) {
    this._data.filingBatchNo = filingBatchNo || ''
  }

  get serialNumber() {
    return this._data.serialNumber
  }

  set serialNumber(serialNumber) {
    this._data.serialNumber = serialNumber || 0
  }

  get companyCode() {
    return this._data.companyCode
  }

  set companyCode(companyCode) {
    this._data.companyCode = companyCode || ''
  }

  get lane() {
    return this._data.lane
  }

  set lane(lane) {
    this._data.lane = lane || ''
  }

  get departureDay() {
    return this._data.departureDay
  }

  set departureDay(departureDay) {
    this._data.departureDay = departureDay || 0
  }

  get abc() {
    return this._data.abc
  }

  set abc(abc) {
    this._data.abc = abc || ''
  }

  get pol() {
    return this._data.pol
  }

  set pol(pol) {
    this._data.pol = pol || ''
  }

  get pod() {
    return this._data.pod
  }

  set pod(pod) {
    this._data.pod = pod || ''
  }

  get eqType() {
    return this._data.eqType
  }

  set eqType(eqType) {
    this._data.eqType = eqType || ''
  }

  get eqSize() {
    return this._data.eqSize
  }

  set eqSize(eqSize) {
    this._data.eqSize = eqSize || ''
  }

  get cargoType() {
    return this._data.cargoType
  }

  set cargoType(cargoType) {
    this._data.cargoType = cargoType || ''
  }

  get cost() {
    return this._data.cost
  }

  set cost(cost) {
    this._data.cost = cost || 0
  }

  get costMin() {
    return this._data.costMin
  }

  set costMin(costMin) {
    this._data.costMin = costMin || 0
  }

  get costMax() {
    return this._data.costMax
  }

  set costMax(costMax) {
    this._data.costMax = costMax || 0
  }

  get commission() {
    return this._data.commission
  }

  set commission(commission) {
    this._data.commission = commission || 0
  }

  get eqDeduct() {
    return this._data.eqDeduct
  }

  set eqDeduct(eqDeduct) {
    this._data.eqDeduct = eqDeduct || 0
  }

  get baf() {
    return this._data.baf
  }

  set baf(baf) {
    this._data.baf = baf || 0
  }

  get caf() {
    return this._data.caf
  }
  set caf(caf) {
    this._data.caf = caf || 0
  }

  get otherSurcharge() {
    return this._data.otherSurcharge
  }

  set otherSurcharge(otherSurcharge) {
    this._data.otherSurcharge = otherSurcharge || 0
  }

  get othc() {
    return this._data.othc
  }

  set othc(othc) {
    this._data.othc = othc || 0
  }

  get dthc() {
    return this._data.dthc
  }

  set dthc(dthc) {
    this._data.dthc = dthc || 0
  }

  get remarks() {
    return this._data.remarks
  }

  set remarks(remarks) {
    this._data.remarks = remarks || ''
  }
}
